import React from 'react';
import useStyles from './styles';

const BackgroundImage = ({ src }) => {
  const classes = useStyles();

  return src ? (
    <div className={classes.imageWrapper}>
      <img src={src} alt="background" className={classes.backgroundImage} />
    </div>
  ) : (
    ''
  );
};

export default BackgroundImage;
